import PageModal from './page-modal.vue';

export default PageModal;
